
export class ShoppingModel {
  id: number;
  id_hash: string;
  name: string;
  cnpj: string;
  logo: string;
  image: string;
  site: string;
  latitude: string;
  longitude: string;
  geohash: string;
  backgroundColor: string;
  textColor: string;
  status: number;
  addressResume: number;
  district: string;
  city: string;
  town: string;

}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/models/shopping.model.ts